<template>
  <v-expansion-panels v-model="panel" multiple focusable class="mt-4">
    <v-expansion-panel readonly>
      <v-expansion-panel-header hide-actions>
        <div class="font-weight-bold">
          <v-row no-gutters>
            <v-col cols="2" class="text-left">Data/Hora Início</v-col>
            <v-col cols="3" class="text-left ml-n1">Data/Hora Fim</v-col>
            <v-col cols="2" class="text-left ml-n2">Conferência</v-col>
            <v-col cols="2" class="text-right ml-n2">Participantes</v-col>
            <v-col cols="3" class="text-center ml-n1" v-if="permissaoOuvirGravacao">Áudio</v-col>
          </v-row>
        </div>
      </v-expansion-panel-header>
    </v-expansion-panel>

    <v-expansion-panel v-for="(dadoRelatorio, key) in dadosRelatorioConferencia" :key="`item_relatorio_conf${key}`">
      <v-expansion-panel-header ripple>
        <v-row align="center" no-gutters>
          <v-col cols="2" class="text-left">{{ getDataHoraInicioConf(dadoRelatorio[0]) }}</v-col>
          <v-col cols="3" class="text-left">{{ getDataHoraFimConf(dadoRelatorio) }}</v-col>
          <v-col cols="2" class="text-left">{{ getConferenciaById(dadoRelatorio[0].conferencia_id) }}</v-col>
          <v-col cols="2" class="text-right">{{ dadoRelatorio.length }}</v-col>
          <v-col cols="3" class="text-center" v-if="permissaoOuvirGravacao">
            <PlayerAudio
              :file="playerAudio(dadoRelatorio[0])"
              :archive="getConferenceAudioPath(dadoRelatorio[0])"
              downloadable
              color="primary"
            />
          </v-col>
        </v-row>
        <template v-slot:actions>
          <v-icon color="orangePcm">$expand</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content color="background">
        <v-timeline dense>
          <v-timeline-item small v-for="item in dadoRelatorio" :key="item.uniqueidCall" fill-dot color="bluePcm">
            <TimeLineItem :dadoRelatorio="item" />
          </v-timeline-item>
        </v-timeline>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import { hostname } from '@/utils/hostname'
import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import relatorioConferenciasStore from '../_store'

import PlayerAudio from './PlayerAudio'
import TimeLineItem from './TimeLineItem'

export default {
  components: { PlayerAudio, TimeLineItem },
  props: {
    dadosRelatorioConferencia: Array,
  },
  data: () => ({
    panel: [],
    permissaoOuvirGravacao: false,
    arrayPermissoesOuvirAudioConferencia: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_TOTAL,
      process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_OUVIR_GRAVACAO,
    ],
  }),

  computed: {
    ...mapGetters('relatorioConferenciasModulePABXStore', ['getConferenciaById']),
  },

  created() {
    registerVuexModule(this.$store, 'relatorioConferenciasModulePABXStore', relatorioConferenciasStore)

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.arrayPermissoesOuvirAudioConferencia.includes(permissionLocalStorage)) {
        this.permissaoOuvirGravacao = true
      }
    })
  },

  methods: {
    ...obtainUserPermissions,

    getDataHoraInicioConf(dadoRelatorio) {
      return moment(dadoRelatorio.dataAtdCall, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
    },

    getDataHoraFimConf(dadoRelatorio) {
      let initialDate = moment(dadoRelatorio[0].dataAtdCall, 'YYYY-MM-DD HH:mm:ss')

      dadoRelatorio.forEach(dado => {
        const finalDate = moment(dado.dateEndCall, 'YYYY-MM-DD HH:mm:ss')
        if (finalDate.isAfter(initialDate)) {
          initialDate = finalDate
        }
      })

      return initialDate.format('DD/MM/YYYY HH:mm:ss')
    },

    getConferenceAudioPath(dadoRelatorio) {
      return `${dadoRelatorio.conferencia_id}-${dadoRelatorio.uniqueidCall}-${dadoRelatorio.linkedid}.wav`
    },

    playerAudio(dadoRelatorio) {
      return `https://${hostname()}/backend/asterisk/relatorios/player/conferencia/${this.getConferenceAudioPath(
        dadoRelatorio
      )}`
    },
  },
}
</script>
